import script from "./AppTopBar.vue?vue&type=script&setup=true&lang=js"
export * from "./AppTopBar.vue?vue&type=script&setup=true&lang=js"

import "./AppTopBar.vue?vue&type=style&index=0&id=6997e8b4&scoped=true&lang=less"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6997e8b4"]])

export default __exports__